module.exports = __webpack_public_path__ + "img/grey-trainings-3.132349ee.png";